<template>
  <div class="register-con">

    <div class="logo-con" v-if="!user">
      <img class="logo" :src="checkQiNiuUrl('ant-wx/202208101113/yungan_logo.png?imageView2/2/w/120/format/png/q/75')" alt="">
      <div class="logo-text">云柑社区</div>
    </div>
    <div class="logo-con user-con" v-else>
      <img class="img" v-if="user.avatar" :src="checkQiNiuUrl(user.avatar, '?imageView2/2/w/160/format/jpg/q/75')" alt="">
      <img class="img" v-if="!user.avatar" :src="checkQiNiuUrl('ant-wx/2022_04_22/not_user.png')" alt="">
      <div class="nickname">{{ user.nickname || '您的好友' }}</div>
      <div class="text">诚邀您加入云柑社区APP</div>
    </div>

    <div class="yungan-text-con">
      <span class="yungan-text">乡村振兴 · 共同富裕</span>
    </div>

    <div class="btn-con">
      <van-button class="btn btn-1" round type="default"
                  :icon="checkQiNiuUrl('ant-wx/202208101113/wechat_icon_w.png')"
                  @click="getAuthor">微信登录</van-button>
      <van-button v-if="!isWechat" class="btn btn-2" round type="default"
                  icon="phone-o"
                  @click="goRegisterPhone">手机登录</van-button>
    </div>



  </div>
</template>

<script>
import { getUserByUserInfo } from '@/api/login'
export default {
  components: {
  },
  data(){
    return{
      isWechat: true, // 是否在微信浏览器打开
      user: 0,
      inviteCode: ''
    }
  },
  created(){
    // this.$router.push({name: 'h5RegisterDownload'})

    this.$toast.clear();
    this.isWechatOpen()
    let query = this.$route.query
    console.log(query)
    this.session('inviteUserInfo', query)

    if(query.inviteCode){
      this.inviteCode = query.inviteCode;
      if(query.inviteCode!=='0608'){
        this.getUserInfo({inviteCode: this.inviteCode})
      }
    }else if(query.inviteUserId){
      this.getUserInfo({openId: query.inviteUserId})
    }else {//当无邀请人时，默认为0608
      let inviteUserInfo = {...this.session('inviteUserInfo'), ...{inviteCode: '0608'}}
      this.session('inviteUserInfo', inviteUserInfo)
    }

    window.setTimeout(()=>{
      document.body.scrollTop=document.documentElement.scrollTop=0
    },1000)
  },
  methods: {
    isWechatOpen(){
      let ua = navigator.userAgent.toLowerCase();
      this.isWechat = ua.indexOf('micromessenger')>0;
      console.log('是否在微信浏览器中打开？===》' + this.isWechat)
    },

    goRegisterPhone(){
      this.$router.push({name: 'h5RegisterPhone'})
    },
    // goRegisterWeiXin(){
    //   this.$router.push({name: 'h5RegisterWeiXin'})
    // },

    getUserInfo(req){
      getUserByUserInfo(req).then(res=>{
        console.log('getUserByUserInfo', res)
        let inviteUserInfo = {}
        if(res.code===200){
          this.user = res.data || {}
          inviteUserInfo = {...this.session('inviteUserInfo'), ...this.user}
        }else {
          inviteUserInfo = {...this.session('inviteUserInfo'), ...{inviteCode: '0608'}}
        }
        console.log('检验后的邀请码为：', inviteUserInfo.inviteCode)
        this.session('inviteUserInfo', inviteUserInfo)
      })
    },

    getAuthor(){
      if(!this.isWechat){
        this.$toast('请在微信中打开本页面后使用微信登录')
      }else {
        if(this.session('h5RegisterOk')){
          this.$router.push({name: 'h5RegisterDownload'})
        }else {
          this.$router.push({name: 'h5RegisterWeiXin'})
        }
      }
    },

  }
}
</script>

<style lang="less" scoped>
.register-con{
  position: relative;
  z-index: 0;
  width: 100%;
  height: 100%;
  //background-color: #fff3e6;
  background: url("@{qnUrl}ant-wx/202208101113/wx_register_bg.png") no-repeat 0 0;
  background-size: 100% 100%;
  color: #333;
  .logo-con{
    width: 100%;
    height: 160px;
    padding-top: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .logo{
      width: 60px;
      height: 60px;
    }
    .logo-text{
      text-align: center;
      font-size: 18px;
      line-height: 35px;
      color: #fff;
    }
    &.user-con{
      .img{
        width: 60px;
        height: 60px;
        border-radius: 50%;
        margin-bottom: 6px;
      }
      .nickname{
        text-align: center;
        font-size: 16px;
        line-height: 20px;
        color: #000;
      }
      .text{
        text-align: center;
        font-size: 14px;
        color: #555;
      }
    }
  }

  .yungan-text-con{
    text-align: center;
    font-size: 26px;
    color: #fff;
  }

  .btn-con{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 160px;
    .btn{
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      background: transparent;
      margin-bottom: 20px;
      color: #fff;
      width: 315px;
      height: 50px;
      border-radius: 25px;
      border: 2px solid #ffffff;

      /deep/ .van-button__icon{
        width: 20px;
        height: 20px;
        .van-icon__image{
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>
